import { Component } from "vue";
import {
  EIntegracoesAPIEnum,
  IntegracoesMercadoPagoOpt,
  IntegracoesPagarMeV5Opt,
  IntegracoesSodexoOpt,
  IntegracoesTicketOpt,
  IntegracoesVROpt
} from "./IntegracoesAPIEnum";
import FormularioNFeIntegracao from "../views/painel/widgets/chamarServico/forms/Nfe/FormularioNFeIntegracao.vue";
import FormularioCadisIntegracao from "../views/painel/widgets/chamarServico/forms/Cadis/FormularioCadisIntegracao.vue";
import FormularioMoozCartoesIntegracao from "../views/painel/widgets/chamarServico/forms/MoozCartoes/FormularioMoozCartoesIntegracao.vue";
import FormularioNexaasIntegracoes from "../views/painel/widgets/chamarServico/forms/Nexaas/FormularioNexaasIntegracoes.vue";
import RedeBannerIntegracoes from "../views/painel/widgets/chamarServico/banners/RedeBannerIntegracoes.vue";
import FormularioPDVDataSystemintegracao from "../views/painel/widgets/chamarServico/forms/PDVDataSystem/FormularioPDVDataSystemintegracao.vue";
import CieloBannerIntegracoes from "../views/painel/widgets/chamarServico/banners/CieloBannerIntegracoes.vue";
import FormularioPluggyIntegracao from "../views/painel/widgets/chamarServico/forms/Pluggy/FormularioPluggyIntegracao.vue";
import EComandaBannerIntegracoes from "../views/painel/widgets/chamarServico/banners/EComandaBannerIntegracoes.vue";
import FormularioPagHiperIntegracao from "../views/painel/widgets/chamarServico/forms/PagHiper/FormularioPagHiperIntegracao.vue";
import MarvinBannerIntegracoes from "../views/painel/widgets/chamarServico/banners/MarvinBannerIntegracoes.vue";
import SigecloudBannerIntegracoes from "../views/painel/widgets/chamarServico/banners/SigecloudBannerIntegracoes.vue";
import FormularioInformativoIntegracao from "../views/painel/widgets/chamarServico/forms/FormularioInformativoIntegracao.vue";

export type TAPIRules = {
  actionByDate?: string;
  actionByRange?: string;
  drawerMode?: "request" | "informative";
  companyEditable?: boolean;
  hideCompanyField?: boolean;
  hideDateField?: boolean;
  hidePeriodSelector?: boolean;
  requiresCompanyLookup?: boolean;
  requiresCompanyOptions?: boolean;
  metadataOptions?: Array<{ label: string; value: string }>;
  metadataLabel?: string;
  metadataDescriptionTitle?: string;
  metadataDescription?: string[];
  forcesRange?: boolean;
  usesCustomChamarServicoGateway?: boolean;
  intervaloData?: number;
  api?: string;
  apiHash: EIntegracoesAPIEnum;
  form?: Component;
  banner?: Component;
  bannerRequiresMetaDataRede?: boolean;
};

type TLegacyRuleDefinition = {
  apiHash: EIntegracoesAPIEnum;
  api: string;
  overrides?: Partial<TAPIRules>;
};

const WS_GENERIC_BY_DATE_RANGE = {
  actionByDate: "/v1/WebserviceAPI/CallWebserviceByDate",
  actionByRange: "/v1/WebserviceAPI/CallWebserviceByRangeDate",
  companyEditable: false
} as const;

const WS_GENERIC_BY_DATE_RANGE_ONE_LOG = {
  actionByDate: "/v1/WebserviceAPI/CallWebserviceByDate",
  actionByRange: "/v1/WebserviceAPI/CallWebserviceByRangeDateWithOneLogPerDay",
  companyEditable: false
} as const;

// TODO[FINC-1618]: mover instruções dos drawers para contrato do backend.
const LEGACY_VR_METADATA_DESCRIPTION = [
  "1. Vendas: Realiza o download dos arquivos de vendas.",
  "2. Pagamentos: Realiza o download dos arquivos de pagamentos."
];

const LEGACY_TICKET_METADATA_DESCRIPTION = [
  "A Ticket funciona de forma assíncrona, ou seja, nós solicitamos a geração de arquivos e depois que estão prontos a gente baixa.",
  "1. Vendas: Essa ação irá solicitar ao sistema da Ticket a geração do arquivo de vendas, mas não baixa esse arquivo, pois a geração do arquivo pode demorar de 1 segundo até 5 minutos.",
  "2. Pagamentos: Essa ação irá solicitar ao sistema da Ticket a geração do arquivo de pagamentos, mas não baixa esse arquivo, pois a geração do arquivo pode demorar de 1 segundo até 5 minutos.",
  "3. Download: Nessa ação o sistema irá baixar todos os arquivos solicitados anteriormente que já foram processados pela Ticket e baixaram para o Finanças.",
  "Se você usar as 3 opções ao mesmo tempo você pode ter a impressão que algum arquivo não foi baixado pois pode ser que na mesma ação não dê tempo da Ticket gerar o arquivo para nosso sistema baixar. Recomendamos que você use a opção 1 e opção 2 em tempos diferente da opção 3, de preferência um intervalo de 1 a 5 minutos, que é mais ou menos o tempo que a Ticket leva para gerar 1 arquivo."
];

const LEGACY_SODEXO_METADATA_DESCRIPTION = [
  "1. Vendas: Realiza o download dos arquivos de vendas.",
  "2. Pagamentos: Os arquivos de pagamentos não estão disponíveis no momento no site, primeiro precisamos solicitar a geração para depois baixar. A geração leva alguns minutos.",
  "3. Download: Essa opção foi feita para baixar os arquivos da Sodexo após a geração. No processo manual você vai usar essa opção após a opção 2. Recomendamos esperar 5 minutos após a chamada da opção 2.",
  "Obs: No processamento automático nosso sistema já se encarrega de fazer esse fluxo de solicitação e depois de um tempo o download do arquivo de pagamento."
];

const LEGACY_PAGARME_V5_METADATA_DESCRIPTION = [
  "1. Vendas: Realiza a busca de movimentos de vendas.",
  "2. Pagamentos: Realiza a busca de movimentos de liquidação.",
  "3. Saques: Realiza a busca de movimentos de saque da conta PagarMe.",
  "Caso nenhuma ação seja selecionada, todas serão executadas."
];

const LEGACY_MERCADOPAGO_METADATA_DESCRIPTION_TITLE = "Tipos de consulta";
const LEGACY_MERCADOPAGO_METADATA_DESCRIPTION = [
  "1. Data da venda: consulta transações com base na data de aprovação.",
  "2. Data da liquidação: consulta transações com base na data de liquidação.",
  "Se nenhuma opção for selecionada, serão consultados todos os tipos automaticamente."
];

const buildRuleMap = (
  baseRule: Partial<TAPIRules>,
  definitions: readonly TLegacyRuleDefinition[]
): Partial<Record<EIntegracoesAPIEnum, TAPIRules>> => {
  return Object.fromEntries(
    definitions.map(({ apiHash, api, overrides }) => [
      apiHash,
      {
        ...baseRule,
        ...overrides,
        apiHash,
        api
      }
    ])
  ) as Partial<Record<EIntegracoesAPIEnum, TAPIRules>>;
};

const LEGACY_HIDE_COMPANY_FIELD_APIS = new Set([
  "Cielo",
  "PDV Data System",
  "MoozCartoes",
  "MercadoPago",
  "PDVLoop",
  "PDV Net",
  "PDV Bling",
  "PDV Colibri",
  "Pdv Nexaas OMS",
  "MVarandas",
  "Vindi",
  "InfinitePay",
  "PDV Legal",
  "Api - SumUp",
  "Api - Alterdata",
  "Api - TagPlus",
  "Api - Pdv ClJoias",
  "Api - Pdv Awise",
  "Webhook - Creditcorp",
  "Api - Adquirente ValidaPix",
  "Api - PDV SuporTI ERP",
  "API - Marvin",
  "API - PDV Microbit",
  "API - PDV Nimbus",
  "API - PDV Zamp",
  "Pdv Lupo",
  "Api - PDV Bling V3",
  "Api - PDV Saurus V2",
  "Api - Adquirente Monedd",
  "Api - Pdv Wizos",
  "PDV Unika",
  "PDV Mitryus",
  "Rede",
  "Api - Adquirente BankPay",
  "Api - CMV - Linx",
  "Api - CMV - Data System",
  "Api - CMV - Cigam",
  "API - PDV Feegow"
]);

const LEGACY_HIDE_DATE_FIELD_APIS = new Set([
  "Pdv Omie",
  "Api - Alterdata",
  "API - PDV Linx Microvix AntecipaÃ§Ãµes",
  "API - PDV Linx EmpÃ³rio",
  "Api - CMV - Linx"
]);

const LEGACY_HIDE_PERIOD_SELECTOR_APIS = new Set([
  "Pdv Omie",
  "API - PDV Linx Microvix AntecipaÃ§Ãµes",
  "API - PDV Linx EmpÃ³rio",
  "Api - CMV - Linx"
]);

const applyLegacyVisualOverrides = (
  rules: Partial<Record<EIntegracoesAPIEnum, TAPIRules>>
): Partial<Record<EIntegracoesAPIEnum, TAPIRules>> => {
  return Object.fromEntries(
    Object.entries(rules).map(([key, rule]) => {
      if (!rule) return [key, rule];

      return [
        key,
        {
          ...rule,
          hideCompanyField:
            rule.hideCompanyField ??
            LEGACY_HIDE_COMPANY_FIELD_APIS.has(rule.api ?? ""),
          hideDateField:
            rule.hideDateField ??
            LEGACY_HIDE_DATE_FIELD_APIS.has(rule.api ?? ""),
          hidePeriodSelector:
            rule.hidePeriodSelector ??
            LEGACY_HIDE_PERIOD_SELECTOR_APIS.has(rule.api ?? "")
        }
      ];
    })
  ) as Partial<Record<EIntegracoesAPIEnum, TAPIRules>>;
};

// TODO[FINC-1618]: mover agrupamentos e orquestração de endpoint/payload para o backend.
//
// TODO[FINC-1618]: validar suporte a range nas integrações genéricas.
const LEGACY_GENERIC_RULES = buildRuleMap(WS_GENERIC_BY_DATE_RANGE, [
  { apiHash: EIntegracoesAPIEnum.PdvAvec, api: "PDV Avec" },
  { apiHash: EIntegracoesAPIEnum.Mvarandas, api: "MVarandas" },
  { apiHash: EIntegracoesAPIEnum.GestaoClick, api: "Gestão Click" },
  { apiHash: EIntegracoesAPIEnum.Vindi, api: "Vindi" },
  { apiHash: EIntegracoesAPIEnum.InfinitePay, api: "InfinitePay" },
  { apiHash: EIntegracoesAPIEnum.PdvProfig, api: "Pdv Profig" },
  { apiHash: EIntegracoesAPIEnum.FitCard, api: "FitCard" },
  { apiHash: EIntegracoesAPIEnum.PdvCake, api: "Pdv Cake" },
  { apiHash: EIntegracoesAPIEnum.PdvOXPI, api: "Pdv OXPI" },
  { apiHash: EIntegracoesAPIEnum.PdvTiny, api: "Pdv Tiny" },
  { apiHash: EIntegracoesAPIEnum.PdvAcconNemo, api: "Pdv Accon Nemo" },
  { apiHash: EIntegracoesAPIEnum.PdvCPlug, api: "Pdv CPlug" },
  {
    apiHash: EIntegracoesAPIEnum.Ticket,
    api: "Ticket",
    overrides: {
      metadataOptions: IntegracoesTicketOpt,
      metadataDescription: LEGACY_TICKET_METADATA_DESCRIPTION
    }
  },
  { apiHash: EIntegracoesAPIEnum.Olist, api: "Olist" },
  { apiHash: EIntegracoesAPIEnum.BusinessShop, api: "Pdv Business Shop" },
  {
    apiHash: EIntegracoesAPIEnum.VarejoFacil,
    api: "Pdv Varejo Fácil",
    overrides: { actionByRange: undefined }
  },
  { apiHash: EIntegracoesAPIEnum.PdvAlloc, api: "Pdv Alloc" },
  { apiHash: EIntegracoesAPIEnum.PdvRoverpix, api: "Pdv Roverpix" },
  {
    apiHash: EIntegracoesAPIEnum.AdquirenteDeliveryDireto,
    api: "Adquirente Delivery Direto"
  },
  { apiHash: EIntegracoesAPIEnum.ApiPdvAwise, api: "Api - Pdv Awise" },
  {
    apiHash: EIntegracoesAPIEnum.ApiSystemFarma,
    api: "Api - SystemFarma",
    overrides: {
      metadataOptions: IntegracoesVROpt,
      metadataDescription: LEGACY_VR_METADATA_DESCRIPTION
    }
  },
  { apiHash: EIntegracoesAPIEnum.Paymee, api: "Webhook - Paymee" },
  {
    apiHash: EIntegracoesAPIEnum.SumUpApi,
    api: "Api - SumUp",
    overrides: {
      metadataOptions: IntegracoesVROpt,
      metadataDescription: LEGACY_VR_METADATA_DESCRIPTION
    }
  },
  { apiHash: EIntegracoesAPIEnum.PdvLupo, api: "Pdv Lupo" },
  {
    apiHash: EIntegracoesAPIEnum.CRMBonus,
    api: "Api - CRM Bônus",
    overrides: {
      metadataOptions: IntegracoesVROpt,
      metadataDescription: LEGACY_VR_METADATA_DESCRIPTION
    }
  },
  { apiHash: EIntegracoesAPIEnum.ApiPdvConsoft, api: "Api - Pdv Consoft" },
  { apiHash: EIntegracoesAPIEnum.PdvAmmo, api: "Pdv Ammo" },
  { apiHash: EIntegracoesAPIEnum.Alterdata, api: "Api - Alterdata" },
  { apiHash: EIntegracoesAPIEnum.ApiC6Pay, api: "Api - C6 Pay" },
  {
    apiHash: EIntegracoesAPIEnum.ApiPdvColibriNovo,
    api: "Api - Pdv Colibri (Novo)"
  },
  { apiHash: EIntegracoesAPIEnum.WebPic, api: "Api - Pdv WebPic" },
  { apiHash: EIntegracoesAPIEnum.ApiValoremPay, api: "Api - Valorem Pay" },
  { apiHash: EIntegracoesAPIEnum.ValoriBankApi, api: "Api - ValoriBank" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvGcom, api: "Api - Pdv Gcom" },
  {
    apiHash: EIntegracoesAPIEnum.ApiPagSeguroAccesstage,
    api: "Api - PagSeguro Accesstage"
  },
  { apiHash: EIntegracoesAPIEnum.ApiTagPlus, api: "Api - TagPlus" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvClJoias, api: "Api - Pdv ClJoias" },
  { apiHash: EIntegracoesAPIEnum.ApiCigam, api: "Api - Cigam" },
  { apiHash: EIntegracoesAPIEnum.ApiCissLive, api: "Api - Ciss Live" },
  {
    apiHash: EIntegracoesAPIEnum.ApiVarejoFacilNFe,
    api: "Api - VarejoFacilNFe"
  },
  {
    apiHash: EIntegracoesAPIEnum.ApiVarejoFacilNFeV2,
    api: "Api - VarejoFacilNFe V2"
  },
  { apiHash: EIntegracoesAPIEnum.ApiVelocePOS, api: "Api - VelocePOS" },
  { apiHash: EIntegracoesAPIEnum.ApiCarMob, api: "Api - CarMob" },
  { apiHash: EIntegracoesAPIEnum.ApiCads, api: "Api - Cads" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvOpdv, api: "Api - Pdv OPDV" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvSaurus, api: "Api - Pdv Saurus" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvVipSystem, api: "Api - Pdv VipSystem" },
  { apiHash: EIntegracoesAPIEnum.ApiAddi, api: "Api - Addi" },
  {
    apiHash: EIntegracoesAPIEnum.WebhookCreditcorp,
    api: "Webhook - Creditcorp"
  },
  { apiHash: EIntegracoesAPIEnum.PdvBling, api: "PDV Bling" },
  { apiHash: EIntegracoesAPIEnum.PdvUnikaOakberry, api: "PDV Unika Oakberry" },
  {
    apiHash: EIntegracoesAPIEnum.PdvPockttchef,
    api: "Api - Pdv PdvPockttchef"
  },
  { apiHash: EIntegracoesAPIEnum.ApiMogoSnack, api: "Api - PDV Mogo Snack" },
  { apiHash: EIntegracoesAPIEnum.ApiSuporTiErp, api: "Api - PDV SuporTI ERP" },
  { apiHash: EIntegracoesAPIEnum.ApiMarvin, api: "API - Marvin" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvMicrobit, api: "API - PDV Microbit" },
  {
    apiHash: EIntegracoesAPIEnum.ApiPdvLinxEmporio,
    api: "API - PDV Linx Empório"
  },
  {
    apiHash: EIntegracoesAPIEnum.SqlPdvAzulSistemas,
    api: "SQL - PDV Azul Sistemas"
  },
  { apiHash: EIntegracoesAPIEnum.PdvBempSql, api: "SQL - PDV Bemp" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvNimbus, api: "API - PDV Nimbus" },
  { apiHash: EIntegracoesAPIEnum.SqlPdvNano, api: "SQL - PDV Nano" },
  {
    apiHash: EIntegracoesAPIEnum.PdvVarejoOnlineAceitaToken,
    api: "Pdv Varejo Online - Aceita Token"
  },
  {
    apiHash: EIntegracoesAPIEnum.ApiPdvClinicaNasNuvens,
    api: "Api - Pdv Clínica nas Nuvens"
  },
  { apiHash: EIntegracoesAPIEnum.ApiPdvBlingV3, api: "Api - PDV Bling V3" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvSaurusV2, api: "Api - PDV Saurus V2" },
  {
    apiHash: EIntegracoesAPIEnum.AdquirenteMonedd,
    api: "Api - Adquirente Monedd"
  },
  { apiHash: EIntegracoesAPIEnum.ApiPdvWizos, api: "Api - Pdv Wizos" },
  {
    apiHash: EIntegracoesAPIEnum.ApiAdquirentePinbank,
    api: "API - Adquirente Pinbank"
  },
  { apiHash: EIntegracoesAPIEnum.ApiPdvEpoc, api: "API - PDV Epoc" },
  { apiHash: EIntegracoesAPIEnum.ApiFrogpay, api: "API - Frogpay" },
  { apiHash: EIntegracoesAPIEnum.BMG, api: "BMG" },
  { apiHash: EIntegracoesAPIEnum.IFoodV3, api: "IFood V3" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvEvup, api: "API - PDV EVUP" },
  {
    apiHash: EIntegracoesAPIEnum.ApiPdvControleCelular,
    api: "Api - PDV ControleCelular"
  },
  {
    apiHash: EIntegracoesAPIEnum.SqlPdvControllerPlus,
    api: "PDV Controller Plus"
  },
  { apiHash: EIntegracoesAPIEnum.ApiPdvPresence, api: "API PDV Presence" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvSaipos, api: "API PDV Saipos" },
  {
    apiHash: EIntegracoesAPIEnum.ApiAdquirentePayGo,
    api: "API Adquirente PayGo"
  },
  { apiHash: EIntegracoesAPIEnum.ApiPdvSaasTec, api: "API PDV SaasTec" },
  { apiHash: EIntegracoesAPIEnum.ApiPdv3SCheckout, api: "API PDV 3S Checkout" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvInfosky, api: "Api - Pdv Infosky" }
]);

const LEGACY_ONE_LOG_RULES = buildRuleMap(WS_GENERIC_BY_DATE_RANGE_ONE_LOG, [
  {
    apiHash: EIntegracoesAPIEnum.MercadoPago,
    api: "MercadoPago",
    overrides: {
      metadataOptions: IntegracoesMercadoPagoOpt,
      metadataLabel: "Deseja consultar por qual data?",
      metadataDescriptionTitle: LEGACY_MERCADOPAGO_METADATA_DESCRIPTION_TITLE,
      metadataDescription: LEGACY_MERCADOPAGO_METADATA_DESCRIPTION
    }
  },
  { apiHash: EIntegracoesAPIEnum.ApiPdvSiso, api: "Api - Pdv Siso" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvWps, api: "Api - Pdv Wps" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvEyemobile, api: "Api - Pdv Eyemobile" },
  { apiHash: EIntegracoesAPIEnum.ApiPdvZamp, api: "API - PDV Zamp" },
  { apiHash: EIntegracoesAPIEnum.ApiFeegow, api: "API - PDV Feegow" },
  {
    apiHash: EIntegracoesAPIEnum.ApiPdvCardapioWeb,
    api: "API - PDV Cardapio Web"
  }
]);

const RAW_API_BY_HASH_NAMES: Partial<Record<EIntegracoesAPIEnum, TAPIRules>> = {
  [EIntegracoesAPIEnum.None]: {
    apiHash: EIntegracoesAPIEnum.None,
    api: "None"
  },
  [EIntegracoesAPIEnum.NFe]: {
    actionByDate: "/NFeAPI/CallNFeWebservicePorEmpresa",
    actionByRange: "/NFeAPI/CallNFeWebserviceByRangeDate",
    apiHash: EIntegracoesAPIEnum.NFe,
    api: "NFe",
    form: FormularioNFeIntegracao
  },
  [EIntegracoesAPIEnum.Stone]: {
    actionByDate: "/v1/WebserviceAPI/CallStoneWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallStoneWebserviceByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.Stone,
    api: "Stone (Antigo)"
  },
  [EIntegracoesAPIEnum.StonePadraoF360]: {
    actionByDate: "/v1/WebserviceAPI/CallStoneWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallStoneWebserviceByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.StonePadraoF360,
    api: "Stone (Novo)"
  },
  [EIntegracoesAPIEnum.CADIS]: {
    actionByDate: "/v1/WebserviceAPI/CallCadisWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallCadisWebserviceByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.CADIS,
    api: "CADIS",
    form: FormularioCadisIntegracao
  },
  [EIntegracoesAPIEnum.MicrovixPadrao]: {
    actionByDate: "/v1/WebserviceAPI/CallMicrovixWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallMicrovixWebserviceByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.MicrovixPadrao,
    api: "Microvix Padrão"
  },
  [EIntegracoesAPIEnum.Ecletica]: {
    actionByDate: "/v1/WebserviceAPI/CallEcleticaWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallEcleticaWebserviceByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.Ecletica,
    api: "Ecletica"
  },
  [EIntegracoesAPIEnum.LinxDegust]: {
    actionByDate: "/v1/WebserviceAPI/CallLinxDegustByDate",
    actionByRange: "/v1/WebserviceAPI/CallLinxDegustByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.LinxDegust,
    api: "Linx Degust V1"
  },
  [EIntegracoesAPIEnum.LinxErpFranquias]: {
    actionByDate: "/v1/WebserviceAPI/CallLinxErpFranquiasByDate",
    actionByRange: "/v1/WebserviceAPI/CallLinxErpFranquiasByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.LinxErpFranquias,
    api: "LinxErpFranquias"
  },
  [EIntegracoesAPIEnum.TOTVSChef]: {
    actionByDate: "/v1/WebserviceAPI/CallTOTVSChefWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallTOTVSChefWebserviceByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.TOTVSChef,
    api: "TOTVSChef"
  },
  [EIntegracoesAPIEnum.MoozCartoes]: {
    actionByDate: "/v1/WebserviceAPI/CallMoozCartoesByDate",
    actionByRange: "/v1/WebserviceAPI/CallMoozCartoesByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.MoozCartoes,
    api: "MoozCartoes",
    form: FormularioMoozCartoesIntegracao
  },
  [EIntegracoesAPIEnum.PDVFollowUp]: {
    actionByDate: "/v1/WebserviceAPI/CallFollowUpByDate",
    actionByRange: "/v1/WebserviceAPI/CallFollowUpByRangeDate",
    companyEditable: false,
    apiHash: EIntegracoesAPIEnum.PDVFollowUp,
    api: "PDV FollowUp"
  },
  [EIntegracoesAPIEnum.PDVUPDI]: {
    actionByDate: "/v1/WebserviceAPI/CallPdvUPDIByDate",
    actionByRange: "/v1/WebserviceAPI/CallPdvUPDIByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.PDVUPDI,
    api: "PDV UPDI"
  },
  [EIntegracoesAPIEnum.PdvNet]: {
    actionByDate: "/v1/WebserviceAPI/CallPdvNetByDate",
    actionByRange: "/v1/WebserviceAPI/CallPdvNetByRangeDate",
    apiHash: EIntegracoesAPIEnum.PdvNet,
    api: "PDV Net"
  },
  [EIntegracoesAPIEnum.PDVLoop]: {
    actionByDate: "/v1/WebserviceAPI/CallPDVLoopWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallPDVLoopWebserviceByRangeDate",
    apiHash: EIntegracoesAPIEnum.PDVLoop,
    api: "PDVLoop"
  },
  [EIntegracoesAPIEnum.WirecardAPI]: {
    actionByDate: "/v1/WebserviceAPI/CallWirecardV2ByDate",
    actionByRange: "/v1/WebserviceAPI/CallWirecardV2ByRangeDate",
    companyEditable: false,
    apiHash: EIntegracoesAPIEnum.WirecardAPI,
    api: "Wirecard"
  },
  [EIntegracoesAPIEnum.OperadoraAdiq]: {
    actionByDate: "/v1/WebserviceAPI/CallAdiqWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallAdiqWebserviceByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.OperadoraAdiq,
    api: "Adiq"
  },
  [EIntegracoesAPIEnum.NextSoft]: {
    actionByDate: "/v1/WebserviceAPI/CallPdvNextSoftByDate",
    actionByRange: "/v1/WebserviceAPI/CallPdvNextSoftByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.NextSoft,
    api: "Pdv Next Soft"
  },
  [EIntegracoesAPIEnum.PagarMe]: {
    actionByDate: "/v1/WebserviceAPI/CallPagarMeByDate",
    actionByRange: "/v1/WebserviceAPI/CallPagarMeByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.PagarMe,
    api: "Pagar Me"
  },
  [EIntegracoesAPIEnum.PagarMe_TrackAndField]: {
    actionByDate: "/v1/WebserviceAPI/CallPagarMeByDate",
    actionByRange: "/v1/WebserviceAPI/CallPagarMeByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.PagarMe,
    api: "Pagar Me - Track & Field"
  },
  [EIntegracoesAPIEnum.PagarMe_SemSplit]: {
    actionByDate: "/v1/WebserviceAPI/CallPagarMeByDate",
    actionByRange: "/v1/WebserviceAPI/CallPagarMeByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.PagarMe,
    api: "Pagar Me - Sem Split"
  },
  [EIntegracoesAPIEnum.PagHiper]: {
    actionByDate: "/v1/WebserviceAPI/CallWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallPagHiperByRangeDate",
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.PagHiper,
    api: "PagHiper",
    form: FormularioPagHiperIntegracao
  },
  [EIntegracoesAPIEnum.PdvGilbarco]: {
    actionByDate: "/v1/WebserviceAPI/CallPdvGilbarcoByDate",
    actionByRange: "/v1/WebserviceAPI/CallPdvGilbarcoByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.PdvGilbarco,
    api: "Pdv Gilbarco"
  },
  [EIntegracoesAPIEnum.Unika]: {
    actionByDate: "/v1/WebserviceAPI/CallPdvUnikaByDate",
    actionByRange: "/v1/WebserviceAPI/CallPdvUnikaByRangeDate",
    apiHash: EIntegracoesAPIEnum.Unika,
    api: "PDV Unika"
  },
  [EIntegracoesAPIEnum.PdvMitryus]: {
    actionByDate: "/v1/WebserviceAPI/CallPdvMitryusByDate",
    actionByRange: "/v1/WebserviceAPI/CallPdvMitryusByRangeDate",
    apiHash: EIntegracoesAPIEnum.PdvMitryus,
    api: "PDV Mitryus"
  },
  [EIntegracoesAPIEnum.PdvNexaasEstoka]: {
    forcesRange: true,
    actionByRange: "/v1/WebserviceAPI/CallPdvNexaasEstokaByRangeDate",
    apiHash: EIntegracoesAPIEnum.PdvNexaasEstoka,
    api: "Pdv Nexaas OMS",
    form: FormularioNexaasIntegracoes
  },
  [EIntegracoesAPIEnum.Rede]: {
    actionByDate: "/v1/WebserviceAPI/CallWebserviceRedeByDate",
    actionByRange: "/v1/WebserviceAPI/CallWebserviceRedeByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    metadataOptions: IntegracoesVROpt,
    metadataDescription: LEGACY_VR_METADATA_DESCRIPTION,
    apiHash: EIntegracoesAPIEnum.Rede,
    api: "Rede",
    banner: RedeBannerIntegracoes,
    bannerRequiresMetaDataRede: true
  },
  [EIntegracoesAPIEnum.PdvColibri]: {
    actionByDate: "/v1/WebserviceAPI/CallPdvColibriByDate",
    actionByRange: "/v1/WebserviceAPI/CallPdvColibriByRangeDate",
    apiHash: EIntegracoesAPIEnum.PdvColibri,
    api: "PDV Colibri"
  },
  [EIntegracoesAPIEnum.LinxDegustV2]: {
    actionByDate: "/v1/WebserviceAPI/CallLinxDegustV2ByDate",
    actionByRange: "/v1/WebserviceAPI/CallLinxDegustV2ByRangeDate",
    apiHash: EIntegracoesAPIEnum.LinxDegustV2,
    api: "LinxDegustV2"
  },
  [EIntegracoesAPIEnum.PDVDataSystem]: {
    actionByDate: "/v1/WebserviceAPI/CallPDVDataSystemWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallPDVDataSystemWebserviceByRangeDate",
    apiHash: EIntegracoesAPIEnum.PDVDataSystem,
    api: "PDV Data System",
    form: FormularioPDVDataSystemintegracao
  },
  [EIntegracoesAPIEnum.BusinessShopCMV]: {
    actionByDate: "/v1/WebserviceAPI/CallCMVBusinessShopByDate",
    actionByRange: "/v1/WebserviceAPI/CallCMVBusinessShopByRange",
    companyEditable: false,
    apiHash: EIntegracoesAPIEnum.BusinessShopCMV,
    api: "Api - CMV - Business Shop"
  },
  [EIntegracoesAPIEnum.DataSystemCMV]: {
    actionByDate: "/v1/WebserviceAPI/CallCMVDataSystemByDate",
    companyEditable: false,
    apiHash: EIntegracoesAPIEnum.DataSystemCMV,
    api: "Api - CMV - Data System"
  },
  [EIntegracoesAPIEnum.ApiCigamCMV]: {
    actionByDate: "/v1/WebserviceAPI/CallCMVApiCigamByDate",
    actionByRange: "/v1/WebserviceAPI/CallCMVApiCigamByRange",
    companyEditable: false,
    apiHash: EIntegracoesAPIEnum.ApiCigamCMV,
    api: "Api - CMV - Cigam"
  },
  [EIntegracoesAPIEnum.PDVLegal]: {
    actionByDate: "/v1/WebserviceAPI/CallPDVLegalWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallPDVLegalWebserviceByRangeDate",
    apiHash: EIntegracoesAPIEnum.PDVLegal,
    api: "PDV Legal"
  },
  [EIntegracoesAPIEnum.ApiAsaas]: {
    actionByDate: "/v1/WebserviceAPI/CallWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallWebserviceByRangeDate",
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiAsaas,
    api: "Api - Asaas"
  },
  [EIntegracoesAPIEnum.VR]: {
    actionByDate: "/v1/WebserviceAPI/CallWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallWebserviceByRangeDate",
    forcesRange: true,
    intervaloData: 365,
    companyEditable: false,
    metadataOptions: IntegracoesVROpt,
    metadataDescription: LEGACY_VR_METADATA_DESCRIPTION,
    apiHash: EIntegracoesAPIEnum.VR,
    api: "VR"
  },
  [EIntegracoesAPIEnum.Sodexo]: {
    actionByDate: "/v1/WebserviceAPI/CallWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallWebserviceByRangeDate",
    forcesRange: true,
    intervaloData: 30,
    companyEditable: false,
    metadataOptions: IntegracoesSodexoOpt,
    metadataDescription: LEGACY_SODEXO_METADATA_DESCRIPTION,
    apiHash: EIntegracoesAPIEnum.Sodexo,
    api: "Sodexo"
  },
  [EIntegracoesAPIEnum.Cielo]: {
    intervaloData: 7,
    companyEditable: false,
    apiHash: EIntegracoesAPIEnum.Cielo,
    api: "Cielo"
  },
  [EIntegracoesAPIEnum.CieloAPI]: {
    drawerMode: "informative",
    hideCompanyField: true,
    apiHash: EIntegracoesAPIEnum.CieloAPI,
    api: "CieloAPI",
    banner: CieloBannerIntegracoes,
    form: FormularioInformativoIntegracao
  },
  [EIntegracoesAPIEnum.ApiPagueVeloz]: {
    actionByDate: "/v1/WebserviceAPI/CallWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallWebserviceByRangeDate",
    intervaloData: 7,
    companyEditable: false,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPagueVeloz,
    api: "API - PagueVeloz"
  },
  [EIntegracoesAPIEnum.Tray]: {
    actionByDate: "/v1/WebserviceAPI/CallWebserviceByDate",
    actionByRange: "/v1/WebserviceAPI/CallWebserviceByRangeDate",
    forcesRange: true,
    companyEditable: false,
    apiHash: EIntegracoesAPIEnum.Tray,
    api: "Tray"
  },
  [EIntegracoesAPIEnum.ApiPluggy]: {
    companyEditable: false,
    usesCustomChamarServicoGateway: true,
    apiHash: EIntegracoesAPIEnum.ApiPluggy,
    api: "Api - Pluggy",
    form: FormularioPluggyIntegracao
  },
  ...LEGACY_GENERIC_RULES,
  ...LEGACY_ONE_LOG_RULES,
  [EIntegracoesAPIEnum.SAT]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.SAT,
    api: "SAT"
  },
  [EIntegracoesAPIEnum.LinkedGourmet]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.LinkedGourmet,
    api: "Linked Gourmet"
  },
  [EIntegracoesAPIEnum.PdvOmie]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    hideDateField: true,
    hidePeriodSelector: true,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.PdvOmie,
    api: "Pdv Omie"
  },
  [EIntegracoesAPIEnum.ApiPdvLinxEmporio]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    hideCompanyField: true,
    hideDateField: true,
    hidePeriodSelector: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvLinxEmporio,
    api: "API - PDV Linx EmpÃ³rio"
  },
  [EIntegracoesAPIEnum.PdvTerasoft]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.PdvTerasoft,
    api: "Pdv Terasoft"
  },
  [EIntegracoesAPIEnum.VarejoOnline]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.VarejoOnline,
    api: "Pdv Varejo Online"
  },
  [EIntegracoesAPIEnum.LinxDegustV3]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.LinxDegustV3,
    api: "Linx Degust V3"
  },
  [EIntegracoesAPIEnum.Softcred]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.Softcred,
    api: "Softcred"
  },
  [EIntegracoesAPIEnum.PdvMoncloa]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.PdvMoncloa,
    api: "Pdv Moncloa"
  },
  [EIntegracoesAPIEnum.ApiPdvLadfood]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvLadfood,
    api: "Pdv Ladfood"
  },
  [EIntegracoesAPIEnum.ApiBlu]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    metadataOptions: IntegracoesVROpt,
    metadataDescription: LEGACY_VR_METADATA_DESCRIPTION,
    apiHash: EIntegracoesAPIEnum.ApiBlu,
    api: "Api - Blu"
  },
  [EIntegracoesAPIEnum.ApiPagaleve]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPagaleve,
    api: "Api - Pagaleve"
  },
  [EIntegracoesAPIEnum.ApiAdyen]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiAdyen,
    api: "Api - Adyen"
  },
  [EIntegracoesAPIEnum.ApiEVO]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiEVO,
    api: "Api - EVO"
  },
  [EIntegracoesAPIEnum.PagarMeV5]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    metadataOptions: IntegracoesPagarMeV5Opt,
    metadataDescription: LEGACY_PAGARME_V5_METADATA_DESCRIPTION,
    apiHash: EIntegracoesAPIEnum.PagarMeV5,
    api: "Pagar Me V5"
  },
  [EIntegracoesAPIEnum.ApiPdvTrier]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvTrier,
    api: "Api - Pdv Trier"
  },
  [EIntegracoesAPIEnum.ApiPdvSagas]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvSagas,
    api: "Api - Pdv Sagas"
  },
  [EIntegracoesAPIEnum.ApiMultiCrediario]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiMultiCrediario,
    api: "Api - MultiCrediario"
  },
  [EIntegracoesAPIEnum.ApiPdvPOSControle]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvPOSControle,
    api: "Api - Pdv POS Controle"
  },
  [EIntegracoesAPIEnum.ApiPdvAutcom]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvAutcom,
    api: "Api - Pdv Autcom"
  },
  [EIntegracoesAPIEnum.ApiPdvTrinks]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvTrinks,
    api: "Api - Pdv Trinks"
  },
  [EIntegracoesAPIEnum.ApiPdvAcert]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvAcert,
    api: "Api - Pdv Acert"
  },
  [EIntegracoesAPIEnum.ApiPdvQuark]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvQuark,
    api: "Api - Pdv Quark"
  },
  [EIntegracoesAPIEnum.ApiPdvSigecloud]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    hideCompanyField: true,
    hideDateField: true,
    hidePeriodSelector: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvSigecloud,
    api: "Api - Pdv Sigecloud",
    banner: SigecloudBannerIntegracoes
  },
  [EIntegracoesAPIEnum.AmeDigital]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.AmeDigital,
    api: "Ame Digital"
  },
  [EIntegracoesAPIEnum.ApiGalaxyPay]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiGalaxyPay,
    api: "Api - GalaxyPay"
  },
  [EIntegracoesAPIEnum.ApiSiegNfe]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiSiegNfe,
    api: "Api - Sieg NFe"
  },
  [EIntegracoesAPIEnum.ApiSoftwareBoss]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiSoftwareBoss,
    api: "Api - Software Boss"
  },
  [EIntegracoesAPIEnum.ApiOperadoraValidaPix]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiOperadoraValidaPix,
    api: "Api - Adquirente ValidaPix"
  },
  [EIntegracoesAPIEnum.ApiPdvErpBSeller]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvErpBSeller,
    api: "API - PDV ERP BSeller"
  },
  [EIntegracoesAPIEnum.ApiPdvPrisma]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvPrisma,
    api: "API - PDV Prisma"
  },
  [EIntegracoesAPIEnum.ApiJusta]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    metadataOptions: IntegracoesVROpt,
    metadataDescription: LEGACY_VR_METADATA_DESCRIPTION,
    apiHash: EIntegracoesAPIEnum.ApiJusta,
    api: "API - Adquirente Justa"
  },
  [EIntegracoesAPIEnum.ApiPdvZeus]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvZeus,
    api: "API - PDV Zeus"
  },
  [EIntegracoesAPIEnum.APIPdvClinicorp]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.APIPdvClinicorp,
    api: "Api - PDV Clinicorp"
  },
  [EIntegracoesAPIEnum.APIPdvDynaset]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.APIPdvDynaset,
    api: "Api - PDV Dynaset"
  },
  [EIntegracoesAPIEnum.APIPdvAutoPet]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.APIPdvAutoPet,
    api: "Api - PDV AutoPet"
  },
  [EIntegracoesAPIEnum.ApiLojaIntegrada]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiLojaIntegrada,
    api: "Api - PDV Loja Integrada"
  },
  [EIntegracoesAPIEnum.ApiInov]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiInov,
    api: "Api - PDV Inov"
  },
  [EIntegracoesAPIEnum.ApiAdquirenteBankPay]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    metadataOptions: IntegracoesVROpt,
    metadataDescription: LEGACY_VR_METADATA_DESCRIPTION,
    apiHash: EIntegracoesAPIEnum.ApiAdquirenteBankPay,
    api: "Api - Adquirente BankPay"
  },
  [EIntegracoesAPIEnum.ApiPdvFollowupGester]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvFollowupGester,
    api: "Api - PDV Followup Gester"
  },
  [EIntegracoesAPIEnum.ApiPdvLinxMicrovixAntecipacoes]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    hideDateField: true,
    hidePeriodSelector: true,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvLinxMicrovixAntecipacoes,
    api: "API - PDV Linx Microvix Antecipações"
  },
  [EIntegracoesAPIEnum.LinxCMV]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    hideCompanyField: true,
    hideDateField: true,
    hidePeriodSelector: true,
    requiresCompanyLookup: true,
    forcesRange: true,
    companyEditable: false,
    apiHash: EIntegracoesAPIEnum.LinxCMV,
    api: "Api - CMV - Linx"
  },
  [EIntegracoesAPIEnum.ApiPdvMyrp]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvMyrp,
    api: "API - PDV Myrp"
  },
  [EIntegracoesAPIEnum.ApiPdvPlainness]: {
    ...WS_GENERIC_BY_DATE_RANGE_ONE_LOG,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.ApiPdvPlainness,
    api: "API - PDV Plainness"
  },
  [EIntegracoesAPIEnum.APIPdvAlmode]: {
    ...WS_GENERIC_BY_DATE_RANGE_ONE_LOG,
    requiresCompanyLookup: true,
    apiHash: EIntegracoesAPIEnum.APIPdvAlmode,
    api: "Api - PDV Almode"
  },
  [EIntegracoesAPIEnum.EComanda]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    apiHash: EIntegracoesAPIEnum.EComanda,
    api: "EComanda",
    banner: EComandaBannerIntegracoes
  },
  [EIntegracoesAPIEnum.ApiMarvin]: {
    ...WS_GENERIC_BY_DATE_RANGE,
    drawerMode: "informative",
    hideCompanyField: true,
    apiHash: EIntegracoesAPIEnum.ApiMarvin,
    api: "API - Marvin",
    banner: MarvinBannerIntegracoes,
    form: FormularioInformativoIntegracao
  },
  [EIntegracoesAPIEnum.PdvVtex]: {
    ...WS_GENERIC_BY_DATE_RANGE_ONE_LOG,
    apiHash: EIntegracoesAPIEnum.PdvVtex,
    api: "PDV Vtex"
  },
  [EIntegracoesAPIEnum.PdvSponte]: {
    ...WS_GENERIC_BY_DATE_RANGE_ONE_LOG,
    apiHash: EIntegracoesAPIEnum.PdvSponte,
    api: "PDV Sponte"
  }
};

export const API_BY_HASH_NAMES = applyLegacyVisualOverrides(
  RAW_API_BY_HASH_NAMES
);
